// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderPhone_header__1Ku8n","titleDiv":"HeaderPhone_titleDiv__1Rrqx","mainTitle":"HeaderPhone_mainTitle__qxP_u","titleLetters":"HeaderPhone_titleLetters__1SYtm"};